/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import Vue from 'vue';
import axios from 'axios'

export default {
  API: {
    FLOWS_FETCH_FILTERS: '/flow/fetchFilters',
    FLOWS_FETCH_DATA: '/flow/flows',
    FLOWS_FETCH_INTENT: '/flow/flowsIntent',
    FLOWS_TOPIC_CONVERSATIONS: '/flow/topicConversations',
    FLOWS_FETCH_MESSAGES: '/flow/getMessage',
  },

  cachedHash: {},
  cancelTokens: [],

  getRequest(authUser, url, headers) {
    if(authUser.accessToken) {
      if(headers == null) headers = {};
      headers["Authorization"] = "Bearer " + authUser.accessToken;
      return axios.get(url, {headers: headers, timeout: 300000});
    }
    else {
      return null;
    }
  },

  postRequest(authUser, url, payload, headers) {
    if(authUser.accessToken) {
      if(headers == null) headers = {};
      headers["Authorization"] = "Bearer " + authUser.accessToken;

      let cancelTokenKey = url;
      if(this.cancelTokens[cancelTokenKey]) {
        // cancel request
        this.cancelTokens[cancelTokenKey].cancel();
      }
      this.cancelTokens[cancelTokenKey] = axios.CancelToken.source();

      let options = {
        timeout: 300000, // timeout in 5 mins
        headers: headers,
        cancelToken: this.cancelTokens[cancelTokenKey].token
      }

      return axios.post(url, payload, options);
    }
    else {
      return null;
    }
  },

  fetchFlowsilters(authUser) {
    let url = Vue.WyConstants.SERVER.FLOW_HOST + this.API.FLOWS_FETCH_FILTERS;
    return this.getRequest(authUser, url);
  },

  fetchFlowsData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.FLOW_HOST + this.API.FLOWS_FETCH_DATA
    return this.postRequest(authUser, url, payload);
  },

  fetchFlowsIntent(authUser, payload) {
    let url = Vue.WyConstants.SERVER.FLOW_HOST + this.API.FLOWS_FETCH_INTENT
    return this.postRequest(authUser, url, payload);
  },

  fetchFlowsTopicConversations(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.FLOWS_TOPIC_CONVERSATIONS + `?mode=${payload.from ? payload.from : '0'}`;
    delete payload.from;
    return this.postRequest(authUser, url, payload);
  },

  fetchFlowsMessages(authUser, payload) {
    let url = Vue.WyConstants.SERVER.FLOW_HOST + this.API.FLOWS_FETCH_MESSAGES
    return this.postRequest(authUser, url, payload);
  },
}